//TODO-SIMEN REPLACE ALL THESE WITH LOCALIZED SOUNDS

import sfTrial1 from '../assets/sounds/no/upperGrades/sf-trial-1.mp3';  
import sfTrial1Wrong from '../assets/sounds/no/upperGrades/sf-trial-1-wrong.mp3';  
import sfTrial1Correct from '../assets/sounds/no/upperGrades/sf-trial-1-correct.mp3';

import sfTrial2 from '../assets/sounds/no/upperGrades/sf-trial-2.mp3';  
import sfTrial2Wrong from '../assets/sounds/no/upperGrades/sf-trial-2-wrong.mp3';  
import sfTrial2Correct from '../assets/sounds/no/upperGrades/sf-trial-2-correct.mp3';

import sfTrial3 from '../assets/sounds/no/upperGrades/sf-trial-3.mp3';  
import sfTrial3Wrong from '../assets/sounds/no/upperGrades/sf-trial-3-wrong.mp3';  
import sfTrial3Correct from '../assets/sounds/no/upperGrades/sf-trial-3-correct.mp3';

import carWrong from 'assets/sounds/no/car-is-wrong.mp3';
import catWrong from 'assets/sounds/no/cat-is-wrong.mp3';
import kombCorrect from 'assets/sounds/no/komb-is-correct.mp3';
import readingWrong from 'assets/sounds/no/lese-is-wrong.mp3';
import lightWrong from 'assets/sounds/no/lys-is-wrong.mp3';

import trial1_1 from '../assets/TrialImagesUpper/trial1_1.png';
import trial1_2 from '../assets/TrialImagesUpper/trial1_2.png';
import trial1_3 from '../assets/TrialImagesUpper/trial1_3.png';
import trial1_4 from '../assets/TrialImagesUpper/trial1_4.png';

import trial2_1 from '../assets/TrialImagesUpper/trial2_1.png';
import trial2_2 from '../assets/TrialImagesUpper/trial2_2.png';
import trial2_3 from '../assets/TrialImagesUpper/trial2_3.png';
import trial2_4 from '../assets/TrialImagesUpper/trial2_4.png';

import trial3_1 from '../assets/TrialImagesUpper/trial3_1.png';
import trial3_2 from '../assets/TrialImagesUpper/trial3_2.png';
import trial3_3 from '../assets/TrialImagesUpper/trial3_3.png';
import trial3_4 from '../assets/TrialImagesUpper/trial3_4.png';


import starterTesten from 'assets/sounds/no/Intro-after-sprakforstaelse.mp3';

export const starterTestenSound = starterTesten;

export const bytteLydenExample = {};

export const tutorialAssignment = {
	id: 1,
	choices: [
		{
			word: 'Lys',
		},
		{
			word: 'Lese',
		},
		{
			word: 'Katt',
		},
		{
			isCorrect: true,
			word: 'Kam',
		},
	],
};
export const assignment1 = [
	{
		id: 1,
		
		mainSound: sfTrial1,
		wrongAnswerText: 'Dette ble dessverre ikke riktig.',
		wrongAnswerSound: sfTrial1Wrong,
		rightAnswerText: 'Du fant helt riktig bilde – så bra!',
		rightAnswerSound: sfTrial1Correct,
		text:
			'1. Se nøye på bildene. Kan du finne bildet som viser at jenta ikke spiser eplet, men holder det? ',
		choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					remark: true,
					word: 'a',
					comment: 'Dette er dessverre feil. Prøv på nytt.',
					sound: lightWrong,
					img: trial1_1,
				},
				{
					groupId:2,
					currentClass:"illustrationItem",
					remark: false,
					word: 'b',
					comment: `Kam er helt riktig. Når du bytter /l/ i lam med /k/, så blir det nye ordet «kam».`,
					sound: kombCorrect,
					img: trial1_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				remark: false,
				word: 'c',
				comment: 'Katt er dessverre feil. Prøv på nytt',
				sound: catWrong,
				img:trial1_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				remark: false,
				word: 'd',
				comment: 'Lese er dessverre feil. Prøv på nytt',
				sound: readingWrong,
				img: trial1_4,
			},
		]}
			
		],
		order:['b']
	},
];

export const assignment2 = [
	{
		id: 2,
		text:
			'2. Velg bildet som viser en mann som leser en bok, men ikke en avis.',	
		mainSound: sfTrial2,
		wrongAnswerText: 'Dette ble dessverre ikke riktig.',
		wrongAnswerSound: sfTrial2Wrong,
		rightAnswerText: 'Du fant helt riktig bilde – så bra!',
		rightAnswerSound: sfTrial2Correct,
		choices: [
			{ choiceGroup: [
				{
					groupId:1,
					currentClass:"illustrationItem",
					remark: true,
					word: 'a',
					comment: 'Lys er dessverre feil. Prøv på nytt.',
					sound: lightWrong,
					img: trial2_1,
				},
				{groupId:2,
					currentClass:"illustrationItem",
					remark: false,
					word: 'b',
					comment: `Kam er helt riktig. Når du bytter /l/ i lam med /k/, så blir det nye ordet «kam».`,
					sound: kombCorrect,
					img: trial2_2,
				},
			]
		},
		{choiceGroup:[
			{
				groupId:3,
				currentClass:"illustrationItem",
				remark: false,
				word: 'c',
				comment: 'Katt er dessverre feil. Prøv på nytt',
				sound: catWrong,
				img:trial2_3,
			},
			{
				groupId:4,
				currentClass:"illustrationItem",
				remark: false,
				word: 'd',
				comment: 'Lese er dessverre feil. Prøv på nytt',
				sound: readingWrong,
				img: trial2_4,
			},
		]},
			
		],
		order:['c']
	},
];

export const assignment3 = [
	{
		id: 3,
		
		mainSound: sfTrial3,
		text:
			'3. Velg bildet som viser en gutt som har en ryggsekk, men ikke en lue',
		wrongAnswerText: 'Dette ble dessverre ikke riktig.',
		wrongAnswerSound: sfTrial3Wrong,
		rightAnswerText: 'Du fant helt riktig bilde – så bra!',
		partialAnswerText:'Half Correct',
		rightAnswerSound: sfTrial3Correct,	
			choices: [
				{ choiceGroup: [
					{
						groupId:1,
						currentClass:"illustrationItem",
						remark: true,
						word: 'a',
						comment: 'Lys er dessverre feil. Prøv på nytt.',
						sound: lightWrong,
						img: trial3_1,
					},
					{
						groupId:2,
					currentClass:"illustrationItem",
						remark: false,
						word: 'b',
						comment: `Kam er helt riktig. Når du bytter /l/ i lam med /k/, så blir det nye ordet «kam».`,
						sound: kombCorrect,
						img: trial3_2,
					}
					
				]
			},
			{choiceGroup:[
				{
					groupId:4,
					currentClass:"illustrationItem",
					remark: false,
					word: 'd',
					comment: 'Katt er dessverre feil. Prøv på nytt',
					sound: catWrong,
					img:trial3_3,
				},
				{
					groupId:5,
					currentClass:"illustrationItem",
					remark: false,
					word: 'e',
					comment: 'Lese er dessverre feil. Prøv på nytt',
					sound: readingWrong,
					img: trial3_4,
				}
			]},	
			],
			order:['a']
	},
];
export const assignment4 = [
	{
		id: 4,
		
		choices: [
			{
				remark: true,
				word: 'modil',
				comment: '',
				sound: carWrong,
				img: '',
			},
			{
				remark: true,
				word: 'vuks',
				comment: '',
				sound: carWrong,
				img: '',
			},
			{
				remark: true,
				word: 'fålk',
				comment: '',
				sound: carWrong,
				img: '',
			},
			{
				remark: true,
				word: 'flynt',
				comment: '',
				sound: carWrong,
				img: '',
			},
		],
	},
];
export const assignment5 = [
	{
		id: 5,
		
		choices: [
			{
				word: 'modil',
				comment: '',
				sound: carWrong,
				img: '',
			},
			{
				word: 'vuks',
				comment: '',
				sound: carWrong,
				img: '',
			},
			{
				word: 'fålk',
				comment: '',
				sound: carWrong,
				img: '',
			},
			{
				word: 'flynt',
				comment: '',
				sound: carWrong,
				img: '',
			},
		],
	},
];

export const assignments = [
	{
		id: 2,
		mainImg: '',
		choices: [
			{
				word: 'modil',
				comment: '',
				sound: carWrong,
				img: '',
			},
			{
				word: 'vuks',
				comment: '',
				sound: carWrong,
				img: '',
			},
			{
				word: 'fålk',
				comment: '',
				sound: carWrong,
				img: '',
			},
			{
				word: 'flynt',
				comment: '',
				sound: carWrong,
				img: '',
			},
		],
	},
	{
		id: 3,
		mainImg: '',
		choices: [
			{
				word: 'vorr',
				comment:
					'Vorr er riktig, fordi det er et spørreord som vi bruker når vi for eksempel lurer på hvor noen befinner seg. Vi skriver ikke ordet slik, men uttaler det slik.',
				sound: carWrong,
				img: '',
			},
			{
				word: 'blastell',
				comment:
					'Blastell er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',
				sound: carWrong,
				img: '',
			},
			{
				word: 'peano',
				comment:
					'Peano er feil, fordi vi sier ikke peano – men piano. Ordet peano finnes ikke på norsk, og det betyr ingen ting.',
				sound: carWrong,
				img: '',
			},
			{
				word: 'knain',
				comment:
					'Knain er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',
				sound: carWrong,
				img: '',
			},
		],
	},
	{
		id: 4,
		mainImg: '',
		choices: [
			{
				word: 'vorr',
				comment:
					'Vorr er riktig, fordi det er et spørreord som vi bruker når vi for eksempel lurer på hvor noen befinner seg. Vi skriver ikke ordet slik, men uttaler det slik.',
				sound: carWrong,
				img: '',
			},
			{
				word: 'blastell',
				comment:
					'Blastell er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',
				sound: carWrong,
				img: '',
			},
			{
				word: 'peano',
				comment:
					'Peano er feil, fordi vi sier ikke peano – men piano. Ordet peano finnes ikke på norsk, og det betyr ingen ting.',
				sound: carWrong,
				img: '',
			},

			{
				word: 'brillter',
				comment:
					'Brillter er feil, fordi vi sier ikke brillter – men briller. Ordet brillter finnes ikke på norsk, og det betyr ingen ting.',
				sound: carWrong,
				img: '',
			},
		],
	},
	{
		id: 5,
		mainImg: '',
		choices: [
			{
				word: 'vorr',
				comment:
					'Vorr er riktig, fordi det er et spørreord som vi bruker når vi for eksempel lurer på hvor noen befinner seg. Vi skriver ikke ordet slik, men uttaler det slik.',
				sound: carWrong,
				img: '',
			},
			{
				word: 'blastell',
				comment:
					'Blastell er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',
				sound: carWrong,
				img: '',
			},

			{
				word: 'knain',
				comment:
					'Knain er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',
				sound: carWrong,
				img: '',
			},
			{
				word: 'brillter',
				comment:
					'Brillter er feil, fordi vi sier ikke brillter – men briller. Ordet brillter finnes ikke på norsk, og det betyr ingen ting.',
				sound: carWrong,
				img: '',
			},
		],
	},
	{
		id: 6,
		mainImg: '',
		choices: [
			{
				word: 'vorr',
				comment:
					'Vorr er riktig, fordi det er et spørreord som vi bruker når vi for eksempel lurer på hvor noen befinner seg. Vi skriver ikke ordet slik, men uttaler det slik.',
				sound: carWrong,
				img: '',
			},
			{
				word: 'blastell',
				comment:
					'Blastell er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',
				sound: carWrong,
				img: '',
			},

			{
				word: 'knain',
				comment:
					'Knain er feil. Dette ordet finnes ikke på norsk, og det betyr ingen ting.',
				sound: carWrong,
				img: '',
			},
			{
				word: 'brillter',
				comment:
					'Brillter er feil, fordi vi sier ikke brillter – men briller. Ordet brillter finnes ikke på norsk, og det betyr ingen ting.',
				sound: carWrong,
				img: '',
			},
		],
	},
];
